import { rootApi } from '@components/rootApi';

type CampaignReport = {
  campaign_id: number;
  report_id: number;
};

export type BackendCampaignType = 'visitation' | 'rsl_sales_only' | 'rsl_visit';

export type CreateCrossChannelExportParams = {
  campaign_type: BackendCampaignType;
  campaign_reports: CampaignReport[];
  report_start_date?: string;
  report_end_date?: string;
};

type CrossChannelExportResponse = {
  data: {
    id: number;
    status: string;
  };
};

const crossChannelExportApi = rootApi.injectEndpoints({
  endpoints: builder => ({
    createCrossChannelExportRequest: builder.mutation<
      CrossChannelExportResponse,
      CreateCrossChannelExportParams
    >({
      query: body => ({
        url: '/api/v3/cross_channel_export_requests',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useCreateCrossChannelExportRequestMutation } =
  crossChannelExportApi;
